import { Middleware } from '@reduxjs/toolkit';

import { fetchUserData } from '../auth.slice';
import { connectSocket, disconnectSocket } from '../basic.slice';

/**
 * Socket middleware to handle automatic socket connection/disconnection
 * based on authentication state changes
 */
export const socketMiddleware: Middleware = (store) => (next) => (action: any) => {
    const result = next(action);

    // When user data is successfully fetched and user is authenticated, connect socket
    if (fetchUserData.fulfilled.match(action)) {
        const state = store.getState();

        if (state.auth.isAuthenticated && state.auth.currentUser) {
            // Reduced timeout for faster socket connection
            setTimeout(() => {
                store.dispatch(connectSocket() as any);
            }, 100);
        }
    }

    // Also listen for when currentUser is set (additional safety net)
    if (action.type === 'auth/setCurrentUser' && action.payload) {
        const state = store.getState();

        // Only connect if not already connected and user is authenticated
        if (state.auth.isAuthenticated && !state.basic.isSocketConnected) {
            setTimeout(() => {
                store.dispatch(connectSocket() as any);
            }, 100);
        }
    }

    // When auth is reset (logout), disconnect socket
    if (action.type === 'auth/resetAuth') {
        store.dispatch(disconnectSocket() as any);
    }

    return result;
};
